export default {
  setOrder(state, order) {
    state.order = order
  },
  setReason(state, reasons) {
    state.reasons = reasons
  },
  setRefundReasons(state, reasons) {
    state.refundReasons = reasons
  },
  setOrderServe(state, serve) {
    state.orderServe = serve
  },
  setRefundDetail(state, detail) {
    state.refundDetail = detail
  },
  setPaySettings(state, settings) {
    state.paySettings = settings
  }
}
